/* eslint-disable */
import { Context } from '@nuxt/types/app'
import Vue from 'vue'

// APIClient
import { APIClient as GmoAPIClient } from '@/infrastructure/network/Gmo/APIClient'
import { APIClient as LegacyAPIClient } from '@/infrastructure/network/Legacy/APIClient'
import { APIClient as MonitaroAPIClient } from '@/infrastructure/network/Monitaro/APIClient'
import { APIClient as UpstreamAPIClient } from '@/infrastructure/network/Upstream/APIClient'
import { APIClient as ZipcloudAPIClient } from '@/infrastructure/network/Zipcloud/APIClient'

// Repositories
import AppRepository from '@/repositories/AppRepository'
import AppointmentRepository from '@/repositories/AppointmentRepository'
import AuthRepository from '@/repositories/AuthRepository'
import CompanyRepository from '@/repositories/CompanyRepository'
import DataRepository from '@/repositories/DataRepository'
import FilterRepository from '@/repositories/FilterRepository'
import HospitalRepository from '@/repositories/HospitalRepository'
import LegacyRepository from '@/repositories/LegacyRepository'
import NotificationRepository from '@/repositories/NotificationRepository'
import OrderRepository from '@/repositories/OrderRepository'
import PaymentRepository from '@/repositories/PaymentRepository'
import RoomRepository from '@/repositories/RoomRepository'
import ScheduleRepository from '@/repositories/ScheduleRepository'
import TalkRepository from '@/repositories/TalkRepository'
import TalkerRepository from '@/repositories/TalkerRepository'
import UserRepository from '@/repositories/UserRepository'

// Gateways
import GmoGateway from '@/gateways/Gmo'
import LegacyGateway from '@/gateways/Legacy'
import MonitaroGateway from '@/gateways/Monitaro'
import UpstreamGateway from '@/gateways/Upstream'
import ZipcloudGateway from '@/gateways/Zipcloud'

// Services
import LogService from '@/services/LogService'
// import RouterService from '@/services/RouterService'

export default (ctx: Context) => {
  const { store, app } = ctx
  const gmoAPIClient = new GmoAPIClient(ctx)
  const legacyAPIClient = new LegacyAPIClient(ctx)
  const monitaroAPIClient = new MonitaroAPIClient(ctx)
  const upstreamAPIClient = new UpstreamAPIClient(ctx)
  const zipcloudAPIClient = new ZipcloudAPIClient(ctx)

  Vue.prototype.App = {
    state: new AppRepository(app.$cookies, store),
    appointment: new AppointmentRepository(app.$cookies, store),
    auth: new AuthRepository(app.$cookies, store),
    company: new CompanyRepository(app.$cookies, store),
    data: new DataRepository(app.$cookies, store),
    filter: new FilterRepository(app.$cookies, store),
    hospital: new HospitalRepository(app.$cookies, store),
    legacy: new LegacyRepository(app.$cookies, store),
    notification: new NotificationRepository(app.$cookies, store),
    order: new OrderRepository(app.$cookies, store),
    payment: new PaymentRepository(store),
    room: new RoomRepository(app.$cookies, store),
    schedule: new ScheduleRepository(app.$cookies, store),
    talk: new TalkRepository(app.$cookies, store),
    talker: new TalkerRepository(app.$cookies, store),
    user: new UserRepository(app.$cookies, store),
    gmoGateway: new GmoGateway(gmoAPIClient),
    legacyGateway: new LegacyGateway(legacyAPIClient),
    monitaroGateway: new MonitaroGateway(monitaroAPIClient),
    upstreamGateway: new UpstreamGateway(upstreamAPIClient),
    zipcloudGateway: new ZipcloudGateway(zipcloudAPIClient),
    logService: new LogService(ctx, app.$sentry),
    sentry: app.$sentry
    // routerService: new RouterService(ctx)
  }

  ctx.App = {
    state: new AppRepository(app.$cookies, store),
    appointment: new AppointmentRepository(app.$cookies, store),
    auth: new AuthRepository(app.$cookies, store),
    company: new CompanyRepository(app.$cookies, store),
    data: new DataRepository(app.$cookies, store),
    filter: new FilterRepository(app.$cookies, store),
    hospital: new HospitalRepository(app.$cookies, store),
    legacy: new LegacyRepository(app.$cookies, store),
    notification: new NotificationRepository(app.$cookies, store),
    order: new OrderRepository(app.$cookies, store),
    payment: new PaymentRepository(store),
    room: new RoomRepository(app.$cookies, store),
    schedule: new ScheduleRepository(app.$cookies, store),
    talk: new TalkRepository(app.$cookies, store),
    talker: new TalkerRepository(app.$cookies, store),
    user: new UserRepository(app.$cookies, store),
    gmoGateway: new GmoGateway(gmoAPIClient),
    legacyGateway: new LegacyGateway(legacyAPIClient),
    monitaroGateway: new MonitaroGateway(monitaroAPIClient),
    upstreamGateway: new UpstreamGateway(upstreamAPIClient),
    zipcloudGateway: new ZipcloudGateway(zipcloudAPIClient),
    logService: new LogService(ctx, app.$sentry),
    sentry: app.$sentry
    // routerService: new RouterService(ctx)
  }
}
